<template>
    <div>
        <modal
            class="new-modal-default"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center p-6" style="background-color: #ffffff !important;">
                <img src="/static/images/parrot.svg" style="height: 10rem !important" />
                <div class="mt-5">
                    <div class="mb-4 fw-500" style="font-size: 18px;">Success</div>
                    <div>Your Sales Forecast has been created successfully.</div>
                    <img class="mt-4" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/qr.svg" alt="" style="width:80px">
                    <div class="my-4 fw-600 fs-15" style="font-size: 18px;">Sales Forecast ID</div>
                    <div class="mb-4" style="font-size: 20px; color: #003cb9;">{{sales_forecast_id}}</div>
                </div>
                <div class="d-flex aligin-items-center justify-content-center mt-6">
                    <button
                        type="button"
                        class="btn btn-new-primary btn-smm"
                        style="box-shadow: none;"
                        @click="hideSelf"
                    >OK</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    props: ["modal_name","sales_forecast_id"],
    methods: {
        hideSelf() {
            this.$modal.hide(this.modal_name);
            this.$emit("closeSalesForecast");
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/alertModals/SaveSalesForecast.vue